const types = {
  CHANGE_CREATION_STATUS_STEP: 'advertisement/CHANGE_CREATION_STATUS_STEP',
  CLEAR_CREATION_STATUS_STEP: 'advertisement/CLEAR_CREATION_STATUS_STEP',
};

export default types;
